import React, { useEffect, useRef, useState } from 'react';
import { Button, Typography, theme } from 'antd';
import { capituloActual, formatoTiempo, normalizarCapitulos } from './capitulos';
import { BASE_CONTENIDO } from './contenido';
import { urlContenido } from './catalogo';

const { Text } = Typography;

// Reproductor de un tutorial: el video y su lista de capítulos (un clic salta a ese momento). Si el JSON de
// capítulos no está o falla, el video se ve igual, solo sin la lista.
//
// Props:
//   tutorial — { titulo, video, poster, capitulos } del catálogo (rutas relativas al contenido).
//   base — URL base del contenido (por defecto, la configurada para la app).
export default function ReproductorTutorial({ tutorial, base = BASE_CONTENIDO }) {
  const { token } = theme.useToken();
  const videoRef = useRef(null);
  const [capitulos, setCapitulos] = useState([]);
  const [actual, setActual] = useState(null);

  const urlCapitulos = urlContenido(base, tutorial.capitulos);
  useEffect(() => {
    setCapitulos([]);
    setActual(null);
    if (!urlCapitulos) return undefined;
    let cancelado = false;
    fetch(urlCapitulos)
      .then((r) => (r.ok ? r.json() : null))
      .then((datos) => {
        if (!cancelado) setCapitulos(normalizarCapitulos(datos));
      })
      .catch(() => {
        if (!cancelado) setCapitulos([]);
      });
    return () => {
      cancelado = true;
    };
  }, [urlCapitulos]);

  const irA = (capitulo) => {
    const video = videoRef.current;
    if (!video) return;
    video.currentTime = capitulo.inicioS;
    setActual(capitulo.id);
    const reproduccion = video.play?.();
    // El navegador puede rechazar la reproducción automática: aún se puede usar los controles.
    if (reproduccion && typeof reproduccion.catch === 'function')
      reproduccion.catch(() => undefined);
  };

  return (
    <div>
      <video
        key={tutorial.video}
        ref={videoRef}
        aria-label={`Video tutorial: ${tutorial.titulo}`}
        src={urlContenido(base, tutorial.video)}
        poster={urlContenido(base, tutorial.poster) ?? undefined}
        controls
        preload="metadata"
        playsInline
        onTimeUpdate={(e) => setActual(capituloActual(capitulos, e.currentTarget.currentTime))}
        style={{
          width: '100%',
          display: 'block',
          borderRadius: token.borderRadiusLG,
          background: '#000',
        }}
      />

      {capitulos.length > 0 ? (
        <div style={{ marginTop: token.marginMD }}>
          <Text strong>Capítulos</Text>
          <div style={{ marginTop: token.marginXS, display: 'flex', flexDirection: 'column' }}>
            {capitulos.map((c) => (
              <Button
                key={c.id}
                type={actual === c.id ? 'primary' : 'text'}
                ghost={actual === c.id}
                aria-current={actual === c.id ? 'true' : undefined}
                onClick={() => irA(c)}
                style={{ justifyContent: 'flex-start', textAlign: 'left' }}
              >
                <span style={{ fontVariantNumeric: 'tabular-nums', opacity: 0.7, marginRight: 8 }}>
                  {formatoTiempo(c.inicioS)}
                </span>
                {c.titulo}
              </Button>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}
